export default "__VITE_ASSET__Dy4eJULO__"